import { useCartState } from "@made-people/grease-cart";
import { useTranslate } from "@made-people/grease-translations";
import { Truck } from "../../assets/icons/Truck";
import { useShippingThreshold } from "../../hooks/use-shipping-threshold";

interface MMFreeShippingBannerProps {
  className?: string;
}

export const MMFreeShippingBanner = ({
  className,
}: MMFreeShippingBannerProps) => {
  const translate = useTranslate();
  const {
    thresholdEnabled,
    isFreeShipping,
    hasFreeShippingGiftcard,
    remaining,
    thresholdFormatted,
    hasCart,
    isFreeShippingByZeroShipping,
  } = useShippingThreshold();

  if (!hasCart || hasFreeShippingGiftcard) return null;

  if (thresholdEnabled && !isFreeShipping) {
    return (
      <div
        className={`flex items-center justify-center gap-2 py-3 px-4 bg-neutral-100 ${className ?? "mb-4"}`}
      >
        <Truck className="w-5 h-5 text-neutral-900 flex-shrink-0" />
        <span className="text-body-sm text-neutral-900">
          {translate("Shipping_Threshold_Countdown", {
            threshold: thresholdFormatted,
            remaining,
          })}
        </span>
      </div>
    );
  }
  if (!isFreeShippingByZeroShipping) return null;
  return (
    <div
      className={`flex items-center justify-center gap-2 py-3 px-4 bg-[#D8EDD3] ${className ?? "mb-4"}`}
    >
      <Truck className="w-5 h-5 text-[#383838] flex-shrink-0" />
      <span className="text-sm text-[#383838]">
        {translate("Free_Shipping_Banner_Text")}
      </span>
    </div>
  );
};
